import script from "./invoice-detail-dialog.vue?vue&type=script&lang=tsx&setup=true"
export * from "./invoice-detail-dialog.vue?vue&type=script&lang=tsx&setup=true"

import "./invoice-detail-dialog.vue?vue&type=style&index=0&id=df6c6732&lang=scss"

const __exports__ = script;

export default __exports__